import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import LuissButton from "../../common_components/luiss_button/luiss_button";

interface C12ButtonData {
    url: string;
    label: string;
}

class C12Button extends TemplateComponent<C12ButtonData> {
    componentRender(data: C12ButtonData): React.ReactElement<any> {
        return (
            <LuissButton key="page-left-button" url={data.url}>{data.label}</LuissButton>
        );
    }

}

export default C12Button;

